var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Input } from '../Input';
import * as Styles from './AutoCompleteInputStyles';
import isTouchDevice from '../../utils/isTouchDevice';
import { IconArrowLeft } from '../../atoms/icons';
import MenuList from './MenuList';
import MenuListItem from './MenuListItem';
export var AutoComplete = function (props) {
    var options = props.options, placeholder = props.placeholder, _a = props.fullScreen, fullScreen = _a === void 0 ? false : _a, _b = props.isOpen, isOpen = _b === void 0 ? false : _b, _c = props.selectedItem, selectedItem = _c === void 0 ? null : _c, _d = props.dataCy, dataCy = _d === void 0 ? 'auto-complete-input' : _d, _e = props.onChange, onChange = _e === void 0 ? function (value) { return value; } : _e, _f = props.loading, loading = _f === void 0 ? false : _f, _g = props.isValid, isValid = _g === void 0 ? false : _g, error = props.error, errorNoMessage = props.errorNoMessage, preSelected = props.preSelected, _h = props.tabFocusTrap, tabFocusTrap = _h === void 0 ? 0 : _h, ariaLiveOnFocus = props.ariaLiveOnFocus;
    var _j = useState(), selectedValue = _j[0], setSelectedValue = _j[1];
    var _k = useState(''), inputValue = _k[0], setInputValue = _k[1];
    var _l = useState(), filteredOptions = _l[0], setFilteredOptions = _l[1];
    var _m = useState(fullScreen ||
        (isTouchDevice() && isOpen) ||
        (isTouchDevice() && filteredOptions && filteredOptions.length > 0) ||
        false), showFullScreen = _m[0], setShowFullScreen = _m[1];
    useEffect(function () {
        setShowFullScreen(fullScreen);
    }, [fullScreen]);
    useEffect(function () {
        setSelectedValue(preSelected || { label: '', value: '' });
    }, [preSelected]);
    var randomString = function (strLength, charSet) {
        if (strLength === void 0) { strLength = 5; }
        if (charSet === void 0) { charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; }
        var result = [];
        while (strLength--) {
            result.push(charSet.charAt(Math.floor(Math.random() * charSet.length)));
        }
        return result.join('');
    };
    var showIdentRef = useRef(randomString());
    var input = useRef();
    var clickOut = function (e) {
        var _a;
        // @ts-ignore
        if (input && !((_a = input.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) && e.target.nodeName !== 'LI') {
            if (filteredOptions !== null)
                setFilteredOptions(null);
        }
    };
    // eslint-disable-next-line no-restricted-globals
    addEventListener('click', clickOut);
    var navIndex = -1;
    var handleKeyDown = function (e) {
        var elements = document.querySelectorAll(".autocomplete-option-".concat(showIdentRef.current));
        var lastSuggestionIndex = elements.length - 1;
        if (e.keyCode === 40) {
            if (navIndex === -1) {
                elements[++navIndex].classList.add('focus');
            }
            else if (navIndex === lastSuggestionIndex) {
                elements[navIndex].classList.remove('focus');
                navIndex = -1;
            }
            else {
                elements[navIndex].classList.remove('focus');
                elements[++navIndex].classList.add('focus');
            }
        }
        else if (e.keyCode === 38) {
            if (navIndex === -1) {
                navIndex = lastSuggestionIndex;
                elements[navIndex].classList.add('focus');
            }
            else if (navIndex === 0) {
                elements[navIndex].classList.remove('focus');
                navIndex = -1;
            }
            else {
                elements[navIndex].classList.remove('focus');
                elements[--navIndex].classList.add('focus');
            }
        }
        else if (e.keyCode === 13) {
            if (navIndex !== -1) {
                if (filteredOptions) {
                    handleOptionClick(filteredOptions[navIndex]);
                }
                else {
                    handleOptionClick(options[navIndex]);
                }
            }
        }
    };
    var handleInputFocus = function () {
        if (!inputValue) {
            setFilteredOptions(options);
        }
    };
    var handleInputChange = function (value) {
        setInputValue(value);
        if (value.length > 0) {
            setFilteredOptions(options.filter(function (option) { return option.label.toLowerCase().includes(value.toLowerCase()); }));
        }
        else {
            setFilteredOptions(options);
        }
    };
    var handleOptionClick = function (option) {
        setSelectedValue(option);
        setFilteredOptions(null);
        onChange(option);
    };
    return (_jsx("div", __assign({ className: "auto-complete-".concat(showIdentRef.current), 
        // @ts-ignore
        ref: input, onKeyDown: handleKeyDown }, { children: _jsx(Styles.Container, __assign({ className: "auto-complete-wrapper", fullScreen: showFullScreen, showLabel: Boolean(isOpen || selectedItem), "data-cy": dataCy }, { children: _jsxs(Styles.AutoSuggestContainer, __assign({ fullScreen: showFullScreen }, { children: [showFullScreen && (_jsx("div", { children: _jsx(Styles.BackButton, __assign({ onClick: function () {
                                setShowFullScreen(false);
                            } }, { children: _jsx(IconArrowLeft, {}) })) })), _jsx(Input, { name: "auto-complete-input", placeHolder: placeholder, type: "text", value: (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.label) || '', onChange: handleInputChange, onFocus: handleInputFocus, loading: loading, valid: isValid, error: error, errorNoMessage: errorNoMessage, className: "auto-complete-input auto-complete-input-".concat(showIdentRef.current), tabFocusTrap: tabFocusTrap, ariaLiveOnFocus: ariaLiveOnFocus }), isOpen && !filteredOptions && (_jsx(MenuList, __assign({ id: "autocomplete-menu autocomplete-menu-".concat(showIdentRef.current) }, { children: options === null || options === void 0 ? void 0 : options.map(function (option, index) { return (_jsx(MenuListItem, __assign({ className: "autocomplete-option-".concat(showIdentRef.current), active: false, onClick: function () { return handleOptionClick(option); }, tabIndex: index }, { children: option.label }), index)); }) }))), filteredOptions && (_jsx(MenuList, __assign({ id: "autocomplete-menu autocomplete-menu-".concat(showIdentRef.current) }, { children: filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function (option, index) { return (_jsx(MenuListItem, __assign({ className: "autocomplete-option autocomplete-option-".concat(showIdentRef.current), active: false, onClick: function () { return handleOptionClick(option); }, tabIndex: index }, { children: option.label }), index)); }) })))] })) })) })));
};
